<template>
  <div class="container">
    <!-- 头部 -->
    <div class="header">
      <img src="../../assets/img/loginLogo.jpg" alt />
    </div>
    <!-- 主体内容 -->
    <div class="main">
      <div class="main-content">
        <!-- 登录 -->
        <div class="ML-right">
          <div class="ML-input">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="账号登录" name="first">
                <!-- 登录表单 -->
                <div class="MLI-login">
                  <div class="MLI-lContent">
                    <el-form ref="form" :model="form">
                      <el-form-item>
                        <el-input
                          placeholder="请输入"
                          v-model="username"
                          @keyup.enter.native="getLogin"
                        >
                          <i slot="suffix" class="el-icon-mobile-phone" style="font-size:20px;"></i>
                        </el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-input
                          v-model="password"
                          placeholder="请输入密码"
                          show-password
                          @keyup.enter.native="getLogin"
                        >
                          <!-- <i slot="suffix" class="el-icon-lock" style="font-size:20px;"></i> -->
                        </el-input>
                      </el-form-item>
                      <el-form-item class="MLI-button">
                        <el-button @click="getLogin">登录</el-button>
                      </el-form-item>
                      <el-form class="demo-form-inline MLI-State" style="position:absoulte:top:0;left:0">
                        <el-form-item>
                          <el-checkbox v-model="checked">自动登录</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                          <ul class="EFI-ul">
                            <span style="font-size:12px">没有账户？</span>
                            <li style="font-size:12px" @click="goRegister">立即注册</li>
                            <span style="font-size:12px">|</span>
                            <li style="font-size:12px" @click="goBackRegister">找回密码</li>
                          </ul>
                        </el-form-item>
                      </el-form>
                    </el-form>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="changeName" name="second">
                <div class="register">
                  <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item prop="name">
                      <el-input v-model="ruleForm.UserAccount" placeholder="请输入手机号">
                        <i slot="suffix" class="el-icon-mobile-phone" style="font-size:20px;"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="name">
                      <el-input
                        v-model="ruleForm.CheckSum"
                        placeholder="请输入验证码"
                        style="width:180px"
                      ></el-input>
                      <el-button
                        type="primary"
                        style="width:100px;text-align:center;"
                        @click="getVerCode"
                        v-if="AuthCode"
                      >获取验证码</el-button>
                      <span class="MinniTime" v-else>倒计时 {{btnText}} s</span>
                    </el-form-item>
                    <el-form-item prop="name">
                      <el-input v-model="ruleForm.UserPassword" type="password" placeholder="请输入密码">
                        <i slot="suffix" class="el-icon-lock" style="font-size:20px;"></i>
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="name">
                      <el-input v-model="ruleForm.CompanyName" placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <!-- 滑动验证 -->
                <div class="onButton">
                  <el-button @click="submitRe">{{changeText}}</el-button>
                </div>
                <div class="clause">
                  <div class="clause_main">
                    <span>注册前请阅读:</span>
                    <span class="CM-color" @click="showPopup">《注册协议》</span>
                    <span class="CM-color" @click="showPopup">《隐私协议》</span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- foot -->
    <div>
      <div class="foot">
        <copy-right></copy-right>
      </div>
    </div>
    <!-- 弹出层 -->
    <div class="popup" v-show="isShowPopup">
      <div class="pop_Main">
        <div style="white-space:pre-wrap;">{{123}}</div>
        <i class="el-icon-close" @click="hidePopup"></i>
      </div>
    </div>

    <el-dialog title="选择账户" :visible.sync="selectCompany" width="500px">
      <ul class="companyList">
        <li v-for="(item, index) in companyArr" :key="index" @click="selectAcc(item.companyId)">
          <p class="p1">{{item.companyName}}</p>
          <p class="p2">{{item.companyScript}}</p>
        </li>
      </ul>
      <p class="tips">提示：单击选择账户进入</p>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import copyRight from "../../components/copyRight";
import {
  Login,
  LoginToGetCompanys,
  RegistPhone,
  RegistCompanyByPhone
} from "@/utils/api";
export default {
  data() {
    return {
      input: "",
      form: {
        name: "",
        psd: ""
      },
      ruleForm: {
        num: ""
      },
      input1: "",
      selectCompany: false,
      checked: true,
      main: "",
      companyArr: [],
      activeName: "first",
      changeName: "账号注册",
      changeText: "同意条款并注册",
      btnText: 60,
      AuthCode: true,
      isShowPopup: false,
      username: null, //登陆用户
      password: null, //登陆密码,
      isLogin:true,
    };
  },
  created() {},
  methods: {
    //切换
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.changeName = "账号注册";
      }
    },
    //登录
    Login() {},
    // 隐藏遮罩层(协议隐藏)
    hidePopup() {
      this.isShowPopup = false;
    },
    // 显示遮罩层(协议显示)
    showPopup() {
      this.isShowPopup = true;
    },
    //  注册页
    goRegister() {
      this.activeName = "second";
    },
    // 找回密码
    goBackRegister() {
      this.activeName = "second";
      this.changeText = "保存";
      this.changeName = "找回密码";
    },
    submitRe() {
      let { UserAccount, CheckSum, CompanyName, UserPassword } = this.ruleForm;
      let CompanyScript = "";

      if (!UserAccount || !CheckSum || !CompanyName || !UserPassword) {
        this.$message.error("公司名、手机号、验证码、密码都不能为空");
        return;
      }

      RegistCompanyByPhone({
        UserAccount,
        CheckSum,
        CompanyName,
        UserPassword,
        CompanyScript
      }).then(res => {
        if (res) {
          this.$message.success("注册成功");
          LoginToGetCompanys({
            UserName: UserAccount,
            UserPassword: UserPassword
          }).then(res => {
            if (res.length == 0) {
              this.$message.error("系统异常");
            } else if (res.length == 1) {
              this.isLogin = false;
              this.selectAcc(res[0].companyId);
            } else if (res.length > 1) {
              this.isLogin = false;
              this.selectCompany = true;
              this.companyArr = res;
            }
          });
        }
      });
    },
    //验证码
    getVerCode() {
      if (this.ruleForm.UserAccount) {
        let that = this;
        this.AuthCode = false;
        this.btnText = 60;
        let timer = setInterval(function() {
          that.btnText = Number(that.btnText) - 1;
          if (that.btnText == 0) {
            that.AuthCode = true;
            clearInterval(timer);
          }
        }, 1000);

        RegistPhone({
          PhoneNumber: this.ruleForm.UserAccount
        }).then(res => {
          if (res) {
            this.$message.success("验证码已发出");
          }
        });
      } else {
        this.$message.error("手机号不能为空");
      }
    },

    //选择账户
    selectAcc(companyId) {
      let params = {
        UserName: this.isLogin?this.username:this.ruleForm.UserAccount,
        UserPassword: this.isLogin?this.password:this.ruleForm.UserPassword,
        companyId
      };
      Login(params).then(res => {
        if (res) {
          let token = res.jwtToken;
          sessionStorage.setItem("token", token);
          sessionStorage.setItem("appToken", res.appToken);
          sessionStorage.setItem("companyId", companyId);
          sessionStorage.setItem("company",  res.company);
          sessionStorage.setItem("userName", res.userName);

          this.$cookies.set('token', token)
          this.$cookies.set("appToken", res.appToken);
          this.$cookies.set("companyId", companyId);
          this.$cookies.set("company",  res.company);
          this.$cookies.set("userName", res.userName);




          this.selectCompany = false;
          this.$message({
            message: "登陆成功!",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.$router.push({
                path: "/"
              });
            }
          });
        }
      });
    },
    // 请求登陆接口
    getLogin() {
      let params = {
        UserName: this.username,
        UserPassword: this.password
      };

      if (!this.username || !this.password) {
        this.$message.error("用户名、密码都不能为空");
        return;
      }

      LoginToGetCompanys(params).then(res => {
        if (res.length == 0) {
          this.$message.error("系统异常");
        } else if (res.length == 1) {
          this.selectAcc(res[0].companyId);
        } else if (res.length > 1) {
          this.selectCompany = true;
          this.companyArr = res;
        }
      });
    }
  },
  components: {
    copyRight
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header {
  width: 100%;
  height: 60px;
  padding-left: 120px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  img {
    height: 40px;
  }
}
// 内容
.main {
  width: 100%;
  overflow: hidden;
  // height: 580px;
  flex: 1;
  background-color: #fff;
  border-bottom: 1px solid #fbfbfb;
  background-size: 100% 100%;
  // background-size: 1920px 580px;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../assets/img/loginBg.png");
  .main-content {
    width: 1200px;
    margin: 0 auto;
    height: 60vh;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .main_left {
      flex: 1;
      height: 100%;
      .Ml-pic {
        width: 100%;
        height: 100%;
        position: relative;
        img {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }
      }
    }
    .ML-right {
      width: 350px;
      height: 440px;
      position: relative;
      .ML-input {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border: 1px solid #e3e3e3;
        position: absolute;
        z-index: 2;
        left: 800px;
        /deep/.el-tabs__item {
          font-size: 22px;
        }
        /deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
          padding-left: 30px;
        }
        /deep/.el-tabs__item {
          padding: 20px 30px 16px;
          height: 76px;
        }
        /deep/.el-tabs__item.is-active {
          color: #fd6a14;
        }
        /deep/.el-tabs__active-bar {
          background-color: #fd6a14;
        }
        /deep/.el-tabs__item:hover {
          color: #fd6a14;
          cursor: pointer;
        }
        .MLI-login {
          width: 100%;
          height: 70%;
          .MLI-lContent {
            width: 90%;
            height: 80%;
            margin: 30px auto;
            /deep/ .el-form {
              height: 75%;
            }
            .el-form-item {
              margin: 20px 0;
              height: 20%;
            }
            /deep/ .MLI-State {
              height: 25%;
            }
            /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
              color: #777;
              font-size: 12px;
            }
            /deep/ .MLI-button {
              height: 15%;
            }
            /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: #fd6a14;
              border-color: #fd6a14;
            }
            .MLI-OI {
              display: flex;
              height: 36px;
              line-height: 33px;
              border: 1px solid #ddd;
              /deep/ .el-input__inner {
                border-radius: 0px;
                border: none;
                height: 90%;
                line-height: 90%;
                outline: 0;
              }
              > div:first-child {
                width: 40px;
                height: 100%;
                margin-right: 10px;
                img {
                  overflow: hidden;
                  width: 100%;
                }
              }
              /deep/ input {
                font-size: 16px;
              }
            }
            .MLI-TI {
              display: flex;
              height: 36px;
              line-height: 33px;
              border: 1px solid #ddd;
              /deep/ .el-input__inner {
                border-radius: 0px;
                border: none;
                height: 90%;
                line-height: 90%;
                outline: 0;
              }
              > div:first-child {
                width: 40px;
                height: 100%;
                margin-right: 10px;
                img {
                  overflow: hidden;
                  width: 100%;
                }
              }
              /deep/ input {
                font-size: 16px;
              }
            }
            .MLI-State {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 15px;
              .EFI-ul {
                display: flex;
                li {
                  cursor: pointer;
                  color: #fd6a14;
                  margin: 0 5px;
                }
              }
            }
            .MLI-button {
              padding: 8px;
              display: block;
              width: 95%;
              margin: 0 auto;
              text-align: center;
              border-radius: 0px;
              border: 0 none;
              font-family: \5fae\8f6f\96c5\9ed1;
              color: #fff;
              margin-bottom: 10px;
              /deep/ .el-form-item__content {
                line-height: 30px;
              }
              /deep/ .el-button {
                background: #ff5400;
                border: none;
                color: #fff;
                width: 100%;
                border-radius: 0;
              }
            }
          }
        }
        .register {
          width: 290px;
          margin: 20px auto;
          margin: 0 auto;
          .MinniTime {
            display: inline-block;
            width: 100px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            font-size: 12px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            margin-left: 8px;
          }
          /deep/.el-button--primary {
            color: #fff;
            background-color: #fff;
            color: #fd6a13;
            border-color: #dcdfe6;
            margin-left: 10px;
          }
        }
        .onButton {
          width: 290px;
          height: 45px;
          border-radius: 3px;
          margin: 20px auto;
          /deep/ .el-button {
            background-color: #fd6a13;
            width: 100%;
            margin: 0 auto;
            color: #fff;
          }
        }
        .clause {
          width: 290px;
          margin: 20px auto;
          .clause_main {
            width: 252px;
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
            .CM-color {
              color: #fd6a14;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

// 弹出层
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .pop_Main {
    position: absolute;
    width: 50%;
    height: 60%;
    left: 25%;
    top: 10%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px 20px 20px;
    overflow-y: auto;
  }
  i {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 14px;
  }
}
.pop_Main::-webkit-scrollbar {
  width: 6px;
}
.pop_Main::-webkit-scrollbar-track {
  background: #e6e6e6;
  border-radius: 2px;
}
.pop_Main::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 10px;
}
.pop_Main::-webkit-scrollbar-thumb:hover {
  background: #333;
}
.pop_Main::-webkit-scrollbar-corner {
  background: #179a16;
}
/deep/ .el-input__suffix {
  display: flex;
  align-items: center;
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
  }
}
.companyList {
  padding-bottom: 20px;
  li {
    padding: 10px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    position: relative;
    left: 0;
    transition: all 1s;
    &:hover {
      left: 10px;
      p {
        color: #ff5400;
      }
    }
    .p1 {
      padding-bottom: 5px;
      font-weight: bold;
    }
  }
}
.tips {
  color: red;
}
</style>